import * as constants from '../../constants';

const INITIAL_STATE = {
    items: [],
    error: null,
    loading: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;
        case constants.ADMIN_ORGANIZATION_LIST_REQUESTED:
            return Object.assign({}, state, {loading: true});
        case constants.ADMIN_ORGANIZATION_LIST_SUCCESS:
            return Object.assign({}, state, {loading: false, items: action.payload.data, error: null});
        case constants.ADMIN_ORGANIZATION_LIST_FAILURE:
            return Object.assign({}, state, {loading: false, items: [], error: action.payload.error});
    }
    return state;
}
